<template>
  <div class="container">
    <div class="label"><slot /></div>
    <div class="scale-container">
      <div
        v-for="i in  numberOfCategories"
        :key="i"
        class="value"
        :class="{'value--selected': selectedValue >= i + minValue - 1, 'value--part-of-role': partOfRole}"
        @click="onClick(i + minValue - 1)">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedValue: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: 2,
    },
    minValue: {
      type: Number,
      default: -2,
    },
    partOfRole: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    numberOfCategories() {
      return (this.maxValue - this.minValue) + 1;
    }
  },

  methods: {
    onClick(newValue) {
      if (this.maxValue - this.minValue === 0) return;
      this.$emit('update:value', newValue);
    }
  }
}
</script>

<style scoped>
.container {
  margin-bottom: 12px;
}

.label {
  padding: 4px 0;
  text-transform: capitalize;
}

.scale-container {
  display: flex;
  gap: 2px;
}

.value {
  flex: 1;
  height: 24px;
  background: #363636;
  cursor: pointer;
}

.value--selected {
  background: #03A93C;
}

.value--part-of-role {
  background: #89DB2C;
}
</style>
